// Patcraft API functions

import axios from "axios";
let callCancelToken = null;
let shawWebApi = document.getElementById("web-api-base-url").value;

export default {
  // Adds product to cart
  addToCart: function(data) {
    if (data.vehicleId) {
      if(!data.hasOwnProperty("isProjectItem")) {
        data.isProjectItem = false
      }
      if(data.hasOwnProperty("isTrayItem")) {
        return axios.get(
          `/patcraftapi/cart/additem/${data.sellingStyleNumber}/${data.colorNumber}/${data.vehicleId}/${data.quantity}/${data.saveForLater}/${data.isProjectItem}/${data.isTrayItem}`
        );
      }
      return axios.get(
        `/patcraftapi/cart/additem/${data.sellingStyleNumber}/${data.colorNumber}/${data.vehicleId}/${data.quantity}/${data.saveForLater}/${data.isProjectItem }`
      );
    } else {
      return axios.get(
        `/patcraftapi/cart/additem/${data.sellingStyleNumber}/${data.colorNumber}`
      );
    }
  },

  //Add tray items to cart
  addTrayItemsToCart: function(cartItems) {
    return axios.post("/patcraftapi/cart/additems", cartItems);
  },

  //Add Multiple Items to Basket
  addMultipleItemsBasket: function(cartItems) {
    return axios.post(`/patcraftapi/cart/addmultiplecartitems`, cartItems);
  },

  //Call Gimble Service
  getGimbleInventory: function(data) {
    return axios.post("/patcraftapi/gimble", data);
  },

  //Get create lab showrooms
  getAllShowrooms: function(data) {
    return axios.get("/patcraftapi/showrooms", data);
  },

  //Get create lab showroom locations
  getAllShowroomLocations: function(data) {
    return axios.get("patcraftapi/showroomlocations", data);
  },

  // Gets product
  getProduct: function(sellingStyleNumber) {
    return axios.get(`/patcraftapi/patcraft/products/${sellingStyleNumber}`);
  },

  // Search product
  searchProduct: function(data) {
    return axios.post("/Search/ProductSearch", data);
  },

  // Gets virtual tray colors
  searchVirtualTray: function(data) {
    return axios.post("/VirtualTray/Search", data);
  },

  // Gets product's colors
  getProductColors: function(sellingStyleNumber) {
    return axios.get(
      `/patcraftapi/patcraft/products/${sellingStyleNumber}/colors`
    );
  },

  getLendingPagePartialView: function(documentID) {
    return axios.get(`/Design-And-Construction-Partial/${documentID}`);
  },

  // Gets collection's products
  getCollectionProducts: function(collectionCode) {
    return axios.get(
      `/patcraftapi/patcraft/collections/${collectionCode}/products`
    );
  },

  isAuthenticated: async function () {
    return axios.get('/Account/IsAuthenticated');
  },

  allowPdfRender: async function () {
    return axios.get('/ProductDocument/AllowPdfRender');
  },

  //Gets compare product spec documents
  getDocuments: function (pdmsDocumentRequest) {
    return axios.get(`/ProductDocument/ProductDocuments?paramSellingStyleNumber=${pdmsDocumentRequest}`);
  },

  // Gets article listing items
  getArticleListingItems: function(query) {
    return axios.post("/blog/articlelistingitems", query);
  },

  // Gets article listing items
  getCoordinatingProducts: function(
    styleNumber,
    colorNumber,
    collectionName,
    similarBy,
    filters
  ) {
    var url = `/productdetail/SimilarProducts?styleNumber=${styleNumber}&colorNumber=${colorNumber}&similarBy=${similarBy}`;
    if (similarBy == 1) {
      url = url + `&collectionName=${encodeURIComponent(collectionName)}`;
    }
    if (similarBy == 0) {
      var product = [];
      var category = [];
      if (filters.productType.Carpet.length) {
        product.push("Carpet");
      }
      if (filters.productType.Resilient.length) {
        product.push("Resilient");
      }
      category = filters.productType.Resilient.concat(
        filters.productType.Carpet
      );
      if (filters.price && filters.price.toString()) {
        url = url + `&price=${filters.price.toString()}`;
      }
      if (product && product.toString()) {
        url = url + `&inventoryType=${product.toString()}`;
      }
      if (category && category.toString()) {
        url = url + `&subtype=${category.toString()}`;
      }
    }
    return axios.get(url);
  },
  getTrustedUser: function(styleNumber, inventoryStyleNumber, colorNumber) {
    return axios.get(
      `/ProductDetail/GetTrustedUser?sellingStyleNumber=${styleNumber}&inventoryStyleNumber=${inventoryStyleNumber}&colorNumber=${colorNumber}`
    );
  },

  async downloadImageFile(fileURL, fileName, backupUrls) {
    let spiner = document.getElementById("wf-download-modal-spiner");
    spiner.classList.remove("d-none");

    return await axios({
      url: fileURL,
      method: "GET",
      responseType: "blob"
    })
      .then(response => {
        spiner.classList.add("d-none");
        const link = document.createElement("a");

        let reader = new window.FileReader();
        reader.readAsDataURL(response.data);
        reader.onload = function() {
          reader.fileName = fileName;
          link.href = reader.result;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        };
      })
      .catch(err => {
        if (backupUrls && backupUrls.length > 0) {
          console.log(`Unable to load image '${fileURL}'. Error: ${err}`);
          fileURL = backupUrls[0];
          backupUrls = backupUrls.splice(0, 1);
          console.log(`Trying to load another size ${fileURL}`);
          this.downloadImageFile(fileURL, fileName, backupUrls);
          return;
        } else {
          let err = document.querySelector(".modal-error-404");
          let spiner = document.getElementById("wf-download-modal-spiner");
          spiner.classList.add("d-none");

          err.classList.remove("d-none");

          setTimeout(() => {
            err.classList.add("d-none");
          }, 2000);
        }
        console.log(err);
        console.log("error");
      });
  },

  // Gets quick search results
  getQuickSearchResults: function(searchTerm, pageNumber = 1, pageSize = 5) {
    return axios.get(
      `/Search/QuickSearch?searchTerm=${encodeURIComponent(
        searchTerm
      )}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  },

  //Get pages on search results page
  getPagesResults: function(searchTerm, pageNumber = 1, pageSize = 16) {
    return axios.get(
      `/Search/PagesSearch?searchTerm=${searchTerm}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  },

  //Get collections on search results page
  getCollectionsResults: function(data) {
    return axios.post("/Search/CollectionSearch", data);
  },

  //Get widen images on Inspiration page
  getInspirationImages: function(data) {
    return axios.post("/Search/Assets", data);
  },

  //Get user addresses on Checkout page
  getUserAddresses: function(data) {
    return axios.post("/Checkout/GetAllUserAddress", data);
  },

  //Save user address on Checkout page
  saveUserAddress: function(data) {
    return axios.post("Checkout/SaveUserAddress", data);
  },

  //Edit user address on Checkout page
  editUserAddress: function(data) {
    return axios.post("Checkout/EditUserAddress", data);
  },

  validateUserAddress: function(data) {
    return axios.post("Checkout/ValidateUserAddress", data);
  },

  //Remove user address on Checkout page
  removeUserAddress: function(data) {
    return axios.post(`Checkout/RemoveAddress?addressId=${data}`);
  },

  countryStates: function(data) {
    return axios.post(`/Checkout/CountryStates?countryCode=${data}`);
  },

  checkOutSubmit: function(data) {
    return axios.post("Checkout/Submit", data);
  },

  //update tranding for inspiration page when images is opened for preview on Inspiration page
  updateInspirationTranding: function(data) {
    return axios.post("/inspiration/UpdateTrending", data);
  },

  //Get filters on VT page
  getVTFilters: function(data) {
    if (callCancelToken) {
      callCancelToken.cancel("Cancel previous request");
    }
    const CancelToken = axios.CancelToken;
    callCancelToken = CancelToken.source();
    return axios
      .post("/VirtualTray/GetFilterList", data, {
        cancelToken: callCancelToken.token
      })
      .then(res => {
        callCancelToken = null;
        return res;
      });
  },

  getMarketSegmentTypes: function(data) {
    return axios.get("/Search/MarketSegmentTypes");
  },

  //Get filters on product search
  getProductFilters: function(data) {
    if (callCancelToken) {
      callCancelToken.cancel("Cancel previous request");
    }
    const CancelToken = axios.CancelToken;
    callCancelToken = CancelToken.source();
    return axios
      .post("/Search/GetFilterList", data, {
        cancelToken: callCancelToken.token
      })
      .then(res => {
        callCancelToken = null;
        return res;
      });
  },

  //Basket Page
  getBasketData: function(data) {
    return axios.get(`/basket/BasketItem`);
  },

  getSaveForLaterBasket: function(data) {
    if (data && data.InventoryStyleNumber && data.SellingStyleNumber) {
      return axios.get(
        `/basket/GetSaveForLaterBasketItems?inventoryStyleNumber=${data.InventoryStyleNumber}&SellingStyleNumber=${data.SellingStyleNumber}&vehicleID=${data.vehicleId}&colorNumber=${data.colorNumber}`
      );
    }
    return axios.get(`/basket/GetSaveForLaterBasketItems`);
  },

  updateSaveForLaterBasket: function(data) {
    return axios.get(
      `/basket/UpdateVehileIdSaveLater?inventoryStyleNumber=${data.inventoryStyleNumber}&SellingStyleNumber=${data.sellingStyleNumber}&VehicleId=${data.vehicleId}`
    );
  },

  getFullTypeSizeSamples: function() {
    return axios.get(`/basket/GetFullTypeSizeSamples`);
  },

  postBasket: function(data) {
    return axios.post("/Basket/PostBasketItemPartial", data);
  },

  clearBasketItems: function(data) {
    return axios.post(`/Basket/Clear?isTrayCart=${data.isTrayCart}&isProjectCart=${data.isProjectCart}`);
  },

  checkOutBasket: function(data) {
    if (
      data.hasOwnProperty("addIdeaBook") &&
      data.hasOwnProperty("declineAddIdeaBook")
    ) {
      return axios.post(
        `/Basket/PostCheckout?checkoutType=${data.checkoutType}&addIdeaBook=${data.addIdeaBook}&declineAddIdeaBook=${data.declineAddIdeaBook}`
      );
    } else {
      return axios.post(
        `/Basket/PostCheckout?checkoutType=${data.checkoutType}`
      );
    }
  },

  shippingAddressUpdate: function(data) {
    return axios.post("/Basket/SetCheckoutType", data);
  },

  compareFeature: function(styleNumber) {
    return axios.get(`/Compare?SellingStyleNumber=${styleNumber}`);
  },

  //BenjaminMoore
  getBenjaminMoore: function(data) {
    let endPoint = `/BenjaminMoore/GetBenjaminMoore/Search?&page=${data.page}&pageSize=${data.pageSize}`;
    if (data.searchTerm && data.searchTerm !== "")
      endPoint = endPoint + `&searchTerm=${data.searchTerm}`;
    if (data.color) {
      let color = "";
      data.color.forEach(element => {
        color = color + `&colors=${element}`;
      });
      endPoint = endPoint + color;
    }
    return axios.get(endPoint);
  },

  getBenjaminMooreSuggestions: function(searchTerm) {
    return axios.get(
      `/BenjaminMoore/GetSuggestions?&searchTerm=${searchTerm}&count=10`
    );
  },

  getVisibleThreeDButton: function(data) {
    return axios.get(
      `/productdetail/GetVisibleThreeDButton?&sellingStyleNumber=${data.sellingStyleNumber}&colorNumber=${data.colorNumber}`
    );
  },

  // Boards Endpoint
  createTray: function(data) {
    return axios.post(`/VirtualTray/Create`, data);
  },
  UpdateTray: function(data) {
    return axios.put(`/VirtualTray/UpdateTray`, {
      updateTrayModel: data
    });
  },

  shareTray: function(data) {
    return axios.post(`/VirtualTray/sharetray`, data);
  },

  SaveUsers: function(data) {
    return axios.post(`/ProjectFeatureUsers/SaveUsers`, data);
  },


  getAllVirtualTray: function(data) {
    return axios.get(`/VirtualTray/GetAll`, {
      params: data,
    });
  },

  deleteVirtualTray: function(data) {
    return axios.delete(`/VirtualTray/DeleteTray`, {
      data: { trayIds: data }
    });
  },

  archivirtualTray: function(data) {
    const isMyProjects = window.location.href.toLowerCase().includes("myprojects");

    const url = isMyProjects ? "/ProjectFeature/ChangeStatus" : "/VirtualTray/ChangeStatus";
    const payload = isMyProjects ? { projectIds: data } : { trayIds: data };

    return axios.put(url, payload);
  },


  getNewToken: function() {
    return axios.get(`/VirtualTray/GetAadAccessToken`);
  },
  getUserTrayId: function(data, aadToken) {
    return axios.get(`/VirtualTray/GetTrayUsers`, {
      params: {
        trayId: data.boardId,
      },

      headers: {
        Authorization: `Bearer ${aadToken}`
      }
    });
  },

  createShareTrayApi: function(data, aadToken) {
    return axios.post(
       `/VirtualTray/CreateTrayUsers`,
      {
        boardId: data.boardId,
        emails: data.emails,
        role: data.role,
        isAdmin: data.isAdmin
      },
      {
        headers: {
          Authorization: `Bearer ${aadToken}`
        }
      }
    );
  },

  editTray: function(data, aadToken) {
    return axios.get(`/VirtualTray/EditTray`, {
      params:{
        trayId:data.trayId,
        trayType:data.trayType
      } ,
      headers: {
        Authorization: `Bearer ${aadToken}`,

      }
    });
  },

  uploadImage:function(data){
    let formData = new FormData()
    formData.append('Id', data.Id ? data.Id : '' );
    formData.append('Asset', data.Asset);
    return axios.post(`/VirtualTray/WidenAssetsUpload`, formData)
  },
  publishTray:function(data,aadToken){
    return axios.post( `/VirtualTray/Publish`,{}, {
      params: {
        trayId: data.id
      },

      headers: {
        Authorization: `Bearer ${aadToken}`
      }
    });
  },
  unpublishTray:function(data,aadToken){
    return axios.post(`/VirtualTray/Unpublish`,{}, {
      params: {
        trayId: data.id,
      },

      headers: {
        Authorization: `Bearer ${aadToken}`
      }
    });
  },

  getIsOrderSampleEnabled: function() {
    return axios.get(`/Header/IsOrderSampleEnabled`);
  },

  // My Projects module

  // Gets Project type data
  getProjectType: function() {
    return axios.get("/ProjectFeature/GetProjectType");
  },

  createProjectFeature:function(data) {
    return axios.post("/ProjectFeature/Create", data);
  },

  updateProjectFeature:function(data) {
    return axios.put("/ProjectFeature/Update", data);
  },

  fetchProjectDetails:function(id) {
    return axios.get(`/ProjectFeature/EditProject`, {
      params:{
        ProjectId:id,
      }
    });
  },

  getProductStyleNumbers:function(id) {
    return axios.get(`/ProjectFeatureItems/GetProductStyleNumbers`, {
      params:{
        sellingStyleNumber:id,
      }
    });
  },

  createProductItem:function(data) {
    return axios.post("/ProjectFeatureItems/CreateProducts", data);
  },

  updateProductItem:function(data) {
    return axios.put("/ProjectFeatureItems/UpdateProductSizeDesc", data);
  },

  updateProductColorImg:function(data) {
    return axios.put("/ProjectFeatureItems/UpdateColors", data);
  },

  updateProductFeatureImg:function(data) {
    return axios.put("/ProjectFeatureItems/UpdateFeatureImage", data);
  },

  deleteProjectFeatureItems: function(data) {
    return axios.delete(`/VirtualTray/RemoveTrayItem`, {
      data: {
        trayId:data.trayId,
        productIds: data.productIds
      }
    });
  },

  fetchTrayDetails:function(id) {
    return axios.get(`/VirtualTray/GetBoardBy`, {
      params:{
        trayId:id,
      }
    });
  },
  fetchDocumetDetails:function(data) {
    return axios.post(`/ProjectFeatureItems/GetDocuments`, data);
  },
  addMultipleDocument:function(data) {
    return axios.post(`/ProjectFeatureItems/CreateMany`, data);
  },


  getAllTrimAndAccessoryData: function(data) {
    return axios.post("TrimsAndAccessories/TrimAndAccessorySearch", data);
  },
  getProductFiltersTnA: function(data) {
    if (callCancelToken) {
      callCancelToken.cancel("Cancel previous request");
    }
    const CancelToken = axios.CancelToken;
    callCancelToken = CancelToken.source();
    return axios
      .post("/TrimsAndAccessories/GetFilterList", data, {
        cancelToken: callCancelToken.token
      })
      .then(res => {
        callCancelToken = null;
        return res;
      });
  },
  
  GetWebPages:function(payload) {
    return axios.get(`/ProjectFeatureItems/GetWebPages?pageSize=${payload.pageSize}`, {});
  },
  GetSuggestions:function(payload) {
    return axios.post(`/ProjectFeatureItems/Suggestions`, payload);
  },

  // Salesforce
  getSalesforceOpportunities: function(email, branding) {
    return axios.get(`/patcraftapi/Opportunities/Email/${email}/Branding/${branding}`);
  },
  createSalesforceOpportunity: function(data) {
    return axios.post(`/patcraftapi/Opportunities`, data);
  },
  getSalesforceOpportunitiesPicklistValues: function() {
    return axios.get(`/patcraftapi/Opportunities/PicklistValues`);
  },
  getSalesforceContact: function(email, branding) {
    return axios.get(`/patcraftapi/Opportunities/Contact/Email/${email}/Branding/${branding}`);
  },
  isOpportunitiesEnabled: function() {
    return axios.get(`/patcraftapi/Opportunities/Enabled`);
  }
    
};


